import { render, staticRenderFns } from "./paymentFail.vue?vue&type=template&id=4d954c34&scoped=true"
import script from "./paymentFail.vue?vue&type=script&lang=js"
export * from "./paymentFail.vue?vue&type=script&lang=js"
import style0 from "./paymentFail.vue?vue&type=style&index=0&id=4d954c34&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d954c34",
  null
  
)

export default component.exports